import React from 'react'


export default ()=>{
    return(
        <div>
            <h1>Documentação</h1>
        </div>
    )
}